var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-center secondary white"},[_vm._v("UNIT TEST")]),_c('br'),_c('br'),_c('testComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }